import React from "react";
import {
  placement_exam_logo,
} from "utils/assets/images";
import { Row, Col } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const PlacementExamFinishSubmission = () => {
  const logo = sessionStorage.getItem("exam_dist_logo");
  const location = useLocation();
  							  const navigate = useNavigate();
  return (
    <div>
      <header className="studentFormHeader">
        <Row align="middle">
          <Col xs={24} sm={24} md={24} className="logo-col">
            <div className="headerRowSectionnew headerFinishScreen">
              <div className="studentFormLogo">
               {logo?<img src={logo} />:null}
              </div>
            </div>
          </Col>
        </Row>
      </header>

      <div>
        <div className="finishSubmissionscreen">
          <h2>Ya terminaste...</h2>
          <p>¡Buena</p>
          <p>suerte!</p>
          <div className="finishSubmissionLogo" onClick={()=>navigate("/login")} >
              <img src={placement_exam_logo} style={{ cursor: "pointer" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlacementExamFinishSubmission;
